import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconStudent({ className, height, title }: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M19.1383 7.32093C19.4179 7.1986 19.4179 6.80196 19.1383 6.67962L10.8017 3.03236C10.2907 2.80878 9.70948 2.80878
      9.19844 3.03236L0.861832 6.67962C0.582214 6.80196 0.582214 7.1986 0.861832 7.32093L3.25008 8.36579V13.0003C3.25008
      13.9901 3.66787 14.9896 4.80258 15.6988C5.87852 16.3712 7.54623 16.7503 10.0001 16.7503C12.4539 16.7503 14.1216
      16.3712 15.1976 15.6988C16.3323 14.9896 16.7501 13.9901 16.7501 13.0003V8.36579L19.1383 7.32093ZM15.2501
      9.02204L10.8017 10.9682C10.2907 11.1918 9.70948 11.1918 9.19844 10.9682L4.75008 9.02204V13.0003C4.75008 13.5104
      4.93228 14.011 5.59758 14.4268C6.32164 14.8793 7.65393 15.2503 10.0001 15.2503C12.3462 15.2503 13.6785 14.8793
      14.4026 14.4268C15.0679 14.011 15.2501 13.5104 15.2501 13.0003V9.02204ZM10.8017 9.33092C10.2907 9.5545 9.70948
      9.5545 9.19844 9.33092L4.60417 7.32093C4.32455 7.1986 4.32455 6.80196 4.60417 6.67962L9.19844 4.66963C9.70948
      4.44605 10.2907 4.44605 10.8017 4.66963L15.396 6.67962C15.6756 6.80196 15.6756 7.1986 15.396 7.32093L10.8017
      9.33092Z</Icon>
  );
}
